import { createApp } from 'vue'
import App from './App.vue'
// Pastikan Anda mengimpor file CSS utama jika ada 

createApp(App).mount('#app')